// Kurze, sprechende Kampagnen-Links für gedruckte Materialien (QR-Codes).
// Beispiel: https://praedigo.com/flyer  ->  Startseite + Tracking
export type ShortLink = {
  /** Zielpfad ohne Sprachpräfix, z. B. "" (Startseite) oder "contact" */
  target: string;
  /** Feste Sprache erzwingen, sonst Browsersprache */
  lang?: "de" | "en";
  source: string;
  medium: string;
  campaign: string;
};

export const SHORT_LINKS: Record<string, ShortLink> = {
  entdecken: { target: "", lang: "de", source: "qr", medium: "print", campaign: "entdecken" },
  bestellen: { target: "bestellung", lang: "de", source: "qr", medium: "print", campaign: "bestellen" },
  flyer: { target: "", lang: "de", source: "flyer", medium: "print", campaign: "flyer" },
  messe: { target: "", lang: "de", source: "messe", medium: "print", campaign: "messe" },
  praxis: { target: "", lang: "de", source: "praxis", medium: "print", campaign: "praxis" },
  karte: { target: "contact", lang: "de", source: "visitenkarte", medium: "print", campaign: "visitenkarte" },
  poster: { target: "", lang: "de", source: "poster", medium: "print", campaign: "poster" },
  start: { target: "bestellung", lang: "de", source: "print", medium: "print", campaign: "start" },
  veemail: { target: "", lang: "de", source: "veemail", medium: "email", campaign: "veemail" },
  adobe: { target: "", lang: "de", source: "adobe", medium: "email", campaign: "adobe" },
  interaktiv: { target: "", lang: "de", source: "interaktiv", medium: "interaktiv", campaign: "interaktiv" },
};
